import { render, staticRenderFns } from "./OrderDiscount.vue?vue&type=template&id=ee2a617c&scoped=true"
import script from "./OrderDiscount.vue?vue&type=script&lang=js"
export * from "./OrderDiscount.vue?vue&type=script&lang=js"
import style0 from "./OrderDiscount.vue?vue&type=style&index=0&id=ee2a617c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2a617c",
  null
  
)

export default component.exports